// extracted by mini-css-extract-plugin
export default {"ContactMe":"Contact_ContactMe__y7ywg","contactCol":"Contact_contactCol__+UyJm","contactForm":"Contact_contactForm__f0AQq"};